<template>
  <el-dialog
    title="数据文件编辑窗口"
    :visible.sync="visible"
    @close="close">

    <el-form :inline="true" :model="FileEditForm" label-position="center">
      <el-form-item label="数据类别">
          <el-select v-model="FileEditForm.currenttable" style="width:200px;" 
                    filterable placeholder="所属表：obs/grb/sem">
                <el-option
                    v-for="item in datatable"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
          </el-select>
      </el-form-item>
      <el-form-item label="数据ID" >
          <el-input v-model="FileEditForm.obs_id" autocomplete="off" style="width:240px;"></el-input>
      </el-form-item>
      <el-form-item label="数据级别">
        <el-select style="width:200px;" v-model="FileEditForm.level"  filterable placeholder="数据级别1L/2L/1G/1P等">
                <el-option
                    v-for="item in FileLevel"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="文件ID  ">
          <el-input v-model="FileEditForm.file_id" autocomplete="off" style="width:240px;"></el-input>
      </el-form-item>
      <el-form-item label="文件路径">
          <el-input v-model="FileEditForm.file_path" autocomplete="off" style="width:680px;"></el-input>
      </el-form-item>
      <el-form-item label="文件版本">
          <el-input v-model="FileEditForm.ver" autocomplete="off" style="width:200px;"></el-input>
      </el-form-item>
      <el-form-item label="归档时间">
          <el-date-picker v-model="FileEditForm.archive_time" value-format="yyyy-MM-dd HH:mm:ss" type="datetime"></el-date-picker>
      </el-form-item>
      <el-form-item label="文件长度">
          <el-input v-model="FileEditForm.file_length" autocomplete="off" style="width:200px;"></el-input>
      </el-form-item>          
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="close">取消</el-button>
      <el-button type="primary" @click="ok">确定</el-button>
    </div>

  </el-dialog>
</template>

<script>
import {DataLevel,filedatatable} from '../common';
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    dialogData: {
      type: Object,
      default(){
        return null
      },
    },
  },
  data() {
    return {
      FileEditForm: {
        currenttable:'',
        obs_id:'',
        level:'',
        file_id:'',
        file_path:'',
        ver:'',
        archive_time:'',
        file_length:'',
        id:'',
      },
      datatable:filedatatable,
      FileLevel:DataLevel,
      visible: false,
    };
  },
  watch: {
    dialogVisible(val) {
      // console.log("dialogVisible传入数据在这里",val);
      this.visible = val;
    },
    dialogData(data){
      // console.log("coreedit传入数据在这里",data);
      this.FileEditForm.currenttable = data.type;
      this.FileEditForm.obs_id = data.obs_id;
      this.FileEditForm.level = data.level;
      this.FileEditForm.file_id = data.file_id;
      this.FileEditForm.file_path = data.file_path;
      this.FileEditForm.ver = data.ver;
      this.FileEditForm.archive_time = data.archive_time;
      this.FileEditForm.file_length = data.file_length;
      this.FileEditForm.id = data.id;
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },
    ok() {
      this.$emit('ok', {
        ...this.FileEditForm,
      });
    },
  }
}
</script>

<style lang="scss" scoped>

</style>
